import { defineStore } from 'pinia';

export const useCommentStore = defineStore('comment', {
  state: () => {
    return {
      areCommentsDisplayed: {},
      isTextEditorDisplayed: {},
    };
  },
  actions: {
    handleDisplayComments({ type, id }) {
      const key = `${type}-${id}`;
      if (!(key in this.areCommentsDisplayed)) {
        this.areCommentsDisplayed = {
          ...this.areCommentsDisplayed,
          [key]: false,
        };
      } else {
        this.areCommentsDisplayed = {
          ...this.areCommentsDisplayed,
          [key]: !this.areCommentsDisplayed[key],
        };
      }
    },
    handleDisplayTextEditor({ type, id }) {
      const key = `${type}-${id}`;
      if (!(key in this.isTextEditorDisplayed)) {
        this.isTextEditorDisplayed = {
          ...this.isTextEditorDisplayed,
          [key]: true,
        };
      } else {
        this.isTextEditorDisplayed = {
          ...this.isTextEditorDisplayed,
          [key]: !this.isTextEditorDisplayed[key],
        };
      }
    },
  },
});
